import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import ContentBlock from "../components/Layout/ContentBlock";
import Spinner from "../components/common/Spinner";
import Container from "../components/Layout/Container";
import {
  IconDocNumber,
  IconExclamation,
  IconNo,
  IconTrash,
  IconWarehouse,
  IconWarehouse2,
} from "../components/Layout/Icons";
import { Modal, Input } from "antd";
import {
  alsoIncomeSetStatus,
  exportToAlso,
  exportToErp,
  getAlsoIncome,
  removeAlsoIncomeItem,
  removeAlsoIncome,
} from "../redux/Actions/also_incomes_action";
const { confirm } = Modal;
import ModalAlsoIncomeModule from "../components/AlsoIncomeModule/ModalAlsoIncomeModule";
import ButtonSecondary from "../components/common/ButtonSecondary";
import TableUi from "../components/Layout/TableUI";
import FilterMenu from "../components/Layout/FilterMenu";
import { MdDateRange } from "react-icons/md";
import PaginationComp from "../components/Dashboard/items/Pagination";
import {
  antdMessageError,
  antdMessageSuccess,
  paginate,
  prettyDateFormat,
} from "../helpers/Utils";
import { CheckBoxInput } from "../components/common/Buttons";
import AntdConfirm from "../helpers/AntdConfirm";
import { getSetting } from "../redux/Actions/settingsAction";
import { QueryClient, QueryClientProvider } from "react-query";
import Axios from "axios";
import dayjs from "dayjs";
import { MdEdit } from "react-icons/md";
import { FaTimes, FaCheck } from "react-icons/fa";
import { setGlobalModal } from "../redux/Actions/orderAction";
import MigrateProductsModal from "../components/orders/accepted_orders/Modals/MigrateProductsModal";
import { addOverFlow, removeOverFlow } from "../helpers/modalFunc";
import { antdAsyncMessageError } from "../helpers/AsyncMessage";

export const queryProductsClient = new QueryClient();

function AlsoIncomeModuleIdScreen({ match, history }) {
  const role_identifier = useSelector(
    (state) => state.auth.user.user_role.identifier
  );
  const role_identifierOld = useSelector((state) => state.auth.user.role);
  const { loading, show_data } = useSelector((state) => state.custom);
  const globalModal = useSelector((state) => state.orders.globalModal);
  const [selected, setSelected] = useState([]);
  const [updatedShowData, setUpdatedShowData] = useState(show_data);
  const [modalPreview, setModalPreview] = useState(false);
  const [statusHistoryModal, setStatusHistoryModal] = useState(false);
  // Pagination
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(50);
  const [exportingStatus, setExportingStatus] = useState(false);

  const dispatch = useDispatch();

  // function count

  useEffect(() => {
    dispatch(getAlsoIncome(match.params.show));
  }, []);

  useEffect(() => {
    dispatch(getAlsoIncome(match.params.show));
    if (modalPreview) {
      addOverFlow();
    } else {
      removeOverFlow();
    }
  }, [modalPreview]);

  useEffect(() => {
    setUpdatedShowData(show_data);
  }, [show_data]);

  useEffect(() => {
    if (!globalModal.isOpen) {
      dispatch(getAlsoIncome(match.params.show));
    }
  }, [globalModal]);

  // const role_accounting = true;
  const role_accounting =
    "accounting" == role_identifier || role_identifierOld == "accounting";

  const role_admin =
    ["admin"].includes(role_identifier) ||
    ["admin"].includes(role_identifierOld);

  const role_manager_admin =
    ["manager", "admin"].includes(role_identifier) ||
    ["manager", "admin"].includes(role_identifierOld);

  const mutationChangeStatus = async (body) => {
    try {
      const response = await Axios.post(
        `/api/v1/also_incomes/${match.params.show}/set_status`,
        {
          also_income: {
            status: body.status,
          },
        }
      );
      antdMessageSuccess();
      return response.data;
    } catch (error) {
      antdMessageError();
      throw error;
    }
  };

  const updateAlsoIncomeItem = async (itemId, comment) => {
    console.log("updateAlsoIncomeItem", itemId, comment);
    const updatedData = { ...updatedShowData };
    const itemIndex = updatedData.also_income_item.findIndex(
      (item) => item?.id === itemId
    );

    if (itemIndex !== -1) {
      updatedData.also_income_item[itemIndex].comment = comment;
      await setUpdatedShowData(updatedData);
      mutationChangeComment();
    } else {
      console.error("Item not found");
    }
  };

  const mutationChangeComment = async () => {
    const updatedItems = updatedShowData.also_income_item.map((item) => ({
      id: item?.id,
      comment: item.comment,
    }));
    try {
      const response = await Axios.put(
        `/api/v1/also_incomes/${match.params.show}`,
        {
          also_incomes: {
            also_income_item_attributes: updatedItems,
          },
        }
      );
      antdMessageSuccess();
      await dispatch(getAlsoIncome(match.params.show));
      return response.data;
    } catch (error) {
      antdMessageError();
      throw error;
    }
  };
  const handleChangeStatuMutation = async (status) => {
    const body = { status };
    try {
      await mutationChangeStatus(body);
      await dispatch(getAlsoIncome(match.params.show));
    } catch (error) {
      console.error("Mutation failed:", error);
    }
  };

  const checkExportingStatus = () => {
    getSetting(`also_income_export_${show_data?.id}`).then((res) => {
      if (!res?.data?.body) return;
      if (res.data.body == "Exported") {
        return setExportingStatus(false);
      }
      setTimeout(() => checkExportingStatus(), 10000);
      return setExportingStatus(true);
    });
  };

  const onMigrateProductsClick = () => {
    dispatch(setGlobalModal(true, [...selected], "MigrateProductsModal"));
  };

  useEffect(() => {
    if (!show_data?.id) return;
    if (!role_accounting) return;
    if (show_data?.in_progress_at) return;
    checkExportingStatus();
  }, [show_data?.id]);

  const handleDelete = async () => {
    try {
      if (
        Array.isArray(show_data?.also_income_item) &&
        show_data.also_income_item.length > 0
      ) {
        antdAsyncMessageError("Please delete all products first");
      } else {
        const { success } = await dispatch(removeAlsoIncome(match.params.show));
        if (success) {
          history.push("/also_income_module");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const items = show_data?.also_income_item || [];

  const total_items = useMemo(() => {
    return show_data?.also_income_item?.length || 0;
  }, [show_data?.also_income_item?.length]);

  const filteredData = useMemo(() => {
    if (!show_data?.also_income_item) return [];
    return paginate(show_data?.also_income_item, pageCount, page);
  }, [page, pageCount, show_data?.also_income_item]);

  const all_selected = useMemo(() => {
    if (loading) return false;
    if (
      filteredData
        .filter((d) => !d.sent_to_rivile_at)
        .every((d) => selected.includes(d?.id))
    )
      return true;
    return false;
  }, [loading, selected?.length, filteredData?.length, page]);

  const hasAlsoIncomeItems =
    Array.isArray(show_data?.also_income_item) &&
    show_data.also_income_item.length > 0;
  const isCanceled = show_data?.status === "canceled";

  // const showCheckox = ["pending", "require_review", "new"].includes(
  //   show_data?.status
  // );
  const showCheckox = true;

  return (
    <Container
      location={{
        locationName: show_data?.document_no || "Nerastas",
        locationUrl: match.url,
      }}
      goBack={() => history.push("/also_income_module")}
    >
      <>
        <>
          <ContentBlock>
            <FilterMenu
              totals={total_items}
              length={items.length}
              onChangeCountPage={setPageCount}
              countPage={pageCount}
              text2="Documents"
            >
              <InformationNav total_items={total_items} show_data={show_data} />
            </FilterMenu>
          </ContentBlock>

          {loading ? (
            <Spinner />
          ) : (
            <ContentBlock>
              <div
                className="table-responsive"
                style={{
                  overflowX: window.innerWidth > 1350 ? "visible" : "auto",
                }}
              >
                <div
                  style={{ paddingLeft: 12, paddingRight: 12 }}
                  className="row"
                >
                {show_data?.id && (
                  <div className="col-2 mb-3 d-flex gap-5">
                    {["pending", "require_review", "new"].includes(
                      show_data?.status
                    ) && (
                        <div>
                          <ButtonSecondary
                            style={{ backgroundColor: "#1F1A54" }}
                            onClick={() => onMigrateProductsClick()}
                          >
                            Migrate marked products
                          </ButtonSecondary>
                        </div>
                      )}
                  </div>
                )}
                  {show_data?.id && (
                    <div className="col-10 mb-3 d-flex justify-content-end gap-5">

                      <div>
                        <ButtonSecondary
                          onClick={() => setStatusHistoryModal(true)}
                        >
                          Status history
                        </ButtonSecondary>
                      </div>
                      <div
                        style={{
                          width: 100,
                        }}
                      >
                        <ButtonSecondary
                          onClick={() => {
                            setModalPreview(true);
                          }}
                        >
                          Edit document
                        </ButtonSecondary>
                      </div>

                      {!role_accounting && show_data?.status == "pending" && (
                        <div
                          style={{
                            width: 125,
                          }}
                        >
                          <ButtonSecondary
                            style={{ backgroundColor: "#000" }}
                            onClick={() =>
                              handleChangeStatuMutation("require_review")
                            }
                          >
                            Confirm PO
                          </ButtonSecondary>
                        </div>
                      )}
                      {(role_accounting || role_admin) && (show_data?.status == "income_started" || show_data?.status == "income_ended") && (
                        <div
                          style={{
                            width: 125,
                          }}
                        >
                          <ButtonSecondary
                            style={{ backgroundColor: "#000000" }}
                            onClick={() =>
                              handleChangeStatuMutation("shortcoming")
                            }
                          >
                            Shortcoming
                          </ButtonSecondary>
                        </div>
                      )}
                      {!role_accounting &&
                        ["require_review"].includes(show_data?.status) && (
                          <div
                            style={{
                              width: 125,
                            }}
                          >
                            <ButtonSecondary
                              style={{ backgroundColor: "#000" }}
                              onClick={() => handleChangeStatuMutation("new")}
                            >
                              Set status to new
                            </ButtonSecondary>
                          </div>
                        )}

                      {(!hasAlsoIncomeItems || isCanceled) && (
                        <div style={{ width: 125 }}>
                          <ButtonSecondary
                            style={{ backgroundColor: "#e61d01" }}
                            onClick={() => handleDelete()}
                          >
                            Delete
                          </ButtonSecondary>
                        </div>
                      )}

                      {role_accounting && selected?.length > 0 && (
                        <div
                          className="ml-2"
                          style={{
                            width: 125,
                          }}
                        >
                          <ButtonSecondary
                            onClick={() => {
                              if (filteredData.length > 90) {
                                alert("You have selected more than 90 products.");
                              } else {
                                confirm({
                                  title: "Are you sure?",
                                  icon: (
                                    <IconExclamation className="text-primary" />
                                  ),
                                  content:
                                    "You will not be able to undo this action",
                                  onOk() {
                                    exportToErp(show_data?.id, selected);
                                  },
                                  onCancel() {
                                    console.log("Cancel");
                                  },
                                });
                              }
                            }}
                            bgColor="#343A40"
                            bgActiveColor="#000"
                          >
                            Import to Rivile
                          </ButtonSecondary>
                        </div>
                      )}

                      {!role_accounting && ![
                        "canceled",
                        "income_started",
                        "income_ended",
                        "shortcoming",
                      ].includes(show_data?.status) && (
                          <div
                            style={{
                              width: 125,
                            }}
                          >
                            <ButtonSecondary
                              style={{ backgroundColor: "#E61D01" }}
                              onClick={() =>
                                handleChangeStatuMutation("canceled")
                              }
                            >
                              Set canceled
                            </ButtonSecondary>
                          </div>
                        )}

                      {role_accounting &&
                        ["new"].includes(show_data?.status) &&
                        show_data?.id &&
                        show_data?.add_to?.toLowerCase() === "office" && (
                          <div
                            className="ml-2"
                            style={{
                              width: 125,
                            }}
                          >
                            <ButtonSecondary
                              onClick={() => {
                                AntdConfirm({
                                  onOk: () => {
                                    console.log("ok11");
                                    dispatch(
                                      alsoIncomeSetStatus(
                                        show_data?.id,
                                        "completed"
                                      )
                                    );
                                  },
                                });
                              }}
                              bgColor="#343A40"
                              bgActiveColor="#000"
                            >
                              Set completed
                            </ButtonSecondary>
                          </div>
                        )}
                      {role_accounting &&
                        show_data?.id &&
                        !show_data?.in_progress_at &&
                        show_data?.status !== "canceled" && (
                          <div
                            className="ml-2"
                            style={{
                              width: 125,
                            }}
                          >
                            <ButtonSecondary
                              loading={exportingStatus}
                              onClick={() => {
                                if (filteredData.length > 90) {
                                  alert("You have selected more than 90 products.");
                                } else {
                                  confirm({
                                    title: "Are you sure?",
                                    icon: (
                                      <IconExclamation className="text-primary" />
                                    ),
                                    content:
                                      "You will not be able to undo this action",
                                    onOk() {
                                      exportToAlso([show_data?.id]).then(
                                        (res) => {
                                          checkExportingStatus();
                                        }
                                      );
                                    },
                                    onCancel() {
                                      console.log("Cancel");
                                    },
                                  });
                                }
                              }}
                              bgColor="#343A40"
                              bgActiveColor="#000"
                            >
                              Export to {show_data?.add_to || "ALSO"}
                            </ButtonSecondary>
                          </div>
                        )}
                      {((role_accounting && ["in_progress", "failed", "income_started", "income_ended"].includes(show_data?.status)) ||
                        ((role_accounting || role_admin) && show_data?.status == "shortcoming")) &&
                        show_data?.id && (
                          <div
                            className="ml-2"
                            style={{
                              width: 125,
                            }}
                          >
                            <ButtonSecondary
                              onClick={() => {
                                AntdConfirm({
                                  onOk: () => {
                                    console.log("ok11");
                                    dispatch(
                                      alsoIncomeSetStatus(
                                        show_data?.id,
                                        "completed"
                                      )
                                    );
                                  },
                                });
                              }}
                              bgColor="#343A40"
                              bgActiveColor="#000"
                            >
                              Set completed
                            </ButtonSecondary>
                          </div>
                        )}
                      {role_accounting &&
                        ["pending"].includes(show_data?.status) &&
                        show_data?.id && (
                          <div
                            className="ml-2"
                            style={{
                              width: 160,
                            }}
                          >
                            <ButtonSecondary
                              onClick={() => {
                                AntdConfirm({
                                  onOk: () => {
                                    console.log("ok11");
                                    dispatch(
                                      alsoIncomeSetStatus(
                                        show_data?.id,
                                        "require_review"
                                      )
                                    );
                                  },
                                });
                              }}
                              bgColor="#343A40"
                              bgActiveColor="#000"
                            >
                              Confirm to require review
                            </ButtonSecondary>
                          </div>
                        )}
                      {role_accounting &&
                        ["pending", "require_review"].includes(
                          show_data?.status
                        ) &&
                        show_data?.id && (
                          <div
                            className="ml-2"
                            style={{
                              width: 125,
                            }}
                          >
                            <ButtonSecondary
                              onClick={() => {
                                AntdConfirm({
                                  onOk: () => {
                                    console.log("ok11");
                                    dispatch(
                                      alsoIncomeSetStatus(show_data?.id, "new")
                                    );
                                  },
                                });
                              }}
                              bgColor="#343A40"
                              bgActiveColor="#000"
                            >
                              Confirm to new
                            </ButtonSecondary>
                          </div>
                        )}
                      {role_accounting &&
                        ["new", "in_progress", "income_started", "income_ended", "shortcoming"].includes(show_data?.status) &&
                        show_data?.id && (
                          <div
                            className="ml-2"
                            style={{
                              width: 125,
                            }}
                          >
                            <ButtonSecondary
                              onClick={() => {
                                AntdConfirm({
                                  onOk: () => {
                                    console.log("ok11");
                                    dispatch(
                                      alsoIncomeSetStatus(
                                        show_data?.id,
                                        "canceled"
                                      )
                                    );
                                  },
                                });
                              }}
                              bgColor="#343A40"
                              bgActiveColor="#000"
                            >
                              Set canceled
                            </ButtonSecondary>
                          </div>
                        )}
                      {role_manager_admin &&
                        ["in_progress"].includes(show_data?.status) &&
                        show_data?.id && (
                          <div
                            className="ml-2"
                            style={{
                              width: 125,
                            }}
                          >
                            <ButtonSecondary
                              onClick={() => {
                                AntdConfirm({
                                  onOk: () => {
                                    console.log("ok11");
                                    dispatch(
                                      alsoIncomeSetStatus(
                                        show_data?.id,
                                        "canceled"
                                      )
                                    );
                                  },
                                });
                              }}
                              bgColor="#343A40"
                              bgActiveColor="#000"
                            >
                              Set canceled
                            </ButtonSecondary>
                          </div>
                        )}
                    </div>
                  )}
                </div>
                <PaginationComp
                  className="mb-0"
                  setPagination={setPage}
                  page={page}
                  totals={total_items}
                  pageCount={pageCount}
                />
                <TableUi
                  ths={[
                    ...(showCheckox
                      ? [
                        <CheckBoxInput
                          checked={all_selected}
                          onChange={() => {
                            setSelected((prev) => {
                              const obj = [...prev];
                              const notSentToRivile = filteredData.filter(
                                (d) => d.sent_to_rivile_at === null
                              );
                              const all_data = notSentToRivile.map(
                                (d) => d?.id
                              );
                              if (all_selected) {
                                return prev.filter(
                                  (d) => !all_data.includes(d)
                                );
                              }
                              return [...new Set([...obj, ...all_data])];
                            });
                          }}
                        />,
                      ]
                      : []),
                    "SKU",
                    "VV SKU",
                    "Barcode",
                    "ALSO Nr.",
                    "Supplier code",
                    "Supplier price",
                    "Title",
                    "Notes",
                    "User",
                    "Total/Used qty",
                    "",
                  ]}
                  total={filteredData?.length || 0}
                >
                  {filteredData.map((item) => {
                    console.log({ item });
                    return (
                      <TableColumn
                        key={item?.id}
                        {...item}
                        validDelete={!show_data?.in_progress_at}
                        selected={selected.includes(item?.id)}
                        setSelected={setSelected}
                        updateAlsoIncomeItem={updateAlsoIncomeItem}
                        match={match}
                        showCheckox={showCheckox}
                      />
                    );
                  })}
                </TableUi>
                <PaginationComp
                  className="mb-0"
                  setPagination={setPage}
                  page={page}
                  totals={total_items}
                  pageCount={pageCount}
                />
              </div>
            </ContentBlock>
          )}
        </>
      </>
      {modalPreview && show_data?.id && (
        <ModalAlsoIncomeModule id={show_data?.id} modalFunc={setModalPreview} />
      )}
      {globalModal.modalName === "MigrateProductsModal" &&
        globalModal.isOpen && (
          <QueryClientProvider client={queryProductsClient}>
            <MigrateProductsModal orders={show_data} />
          </QueryClientProvider>
        )}
      <Modal
        title="Status history"
        open={statusHistoryModal}
        onCancel={() => setStatusHistoryModal(false)}
        footer={null}
        width={700}
      >
        {(show_data?.status_history?.filter(Boolean) || []).length === 0 ? (
          <p>No status history available.</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #f0f0f0", textAlign: "left" }}>
                <th style={{ padding: "8px 12px" }}>From</th>
                <th style={{ padding: "8px 12px" }}>To</th>
                <th style={{ padding: "8px 12px" }}>Changed at</th>
                <th style={{ padding: "8px 12px" }}>Changed by</th>
              </tr>
            </thead>
            <tbody>
              {show_data.status_history.filter(Boolean).map((entry, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #f0f0f0" }}>
                  <td style={{ padding: "8px 12px" }}>{entry.status_from || "-"}</td>
                  <td style={{ padding: "8px 12px" }}>{entry.status_to || "-"}</td>
                  <td style={{ padding: "8px 12px" }}>{entry.changed_at || "-"}</td>
                  <td style={{ padding: "8px 12px" }}>{entry.changed_by || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal>
    </Container>
  );
}

export default AlsoIncomeModuleIdScreen;

function TableColumn({
  id,
  qty,
  used_qty,
  sku,
  barcode,
  product_title,
  user_full,
  validDelete,
  selected,
  setSelected,
  sent_to_rivile_at,
  supplier_code,
  supplier_price,
  comment,
  updateAlsoIncomeItem,
  match,
  showCheckox,
  also_item_code,
  vv_sku
}) {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [commentValue, setCommentValue] = useState(comment);

  return (
    <TableUi.tr className="align-middle tableColumn">
      {showCheckox && (
        <TableUi.td className="p-left">
          <CheckBoxInput
            checked={selected && sent_to_rivile_at === null}
            disabled={sent_to_rivile_at !== null}
            onChange={() => {
              setSelected((prev) => {
                let obj = [...prev];
                if (obj.includes(id)) {
                  return obj.filter((d) => d !== id);
                }
                obj.push(id);
                return obj;
              });
            }}
          />
        </TableUi.td>
      )}
      <TableUi.td className="align-middle">
        <div style={showCheckox ? {} : { paddingLeft: 10 }}>{sku}</div>
      </TableUi.td>
      <TableUi.td className="align-middle">{vv_sku || "-"}</TableUi.td>
      <TableUi.td className="align-middle">{barcode}</TableUi.td>
      <TableUi.td className="align-middle">
        {also_item_code === 0 || also_item_code === null ? "-" : also_item_code}
      </TableUi.td>
      <TableUi.td className="align-middle">{supplier_code}</TableUi.td>
      <TableUi.td className="align-middle">
        {supplier_price && supplier_price + " €"}
      </TableUi.td>
      <TableUi.td className="align-middle">
        <div className="d-flex flex-wrap-wrap">{product_title}</div>
      </TableUi.td>
      <TableUi.td className="align-middle">
        {isEditing ? (
          <div className="d-flex flex-row gap-5">
            <Input
              value={commentValue}
              onChange={(e) => setCommentValue(e.target.value)}
            />
            <div
              className="cursor-pointer d-flex align-items-center justify-content-center"
              onClick={() => {
                updateAlsoIncomeItem(id, commentValue);
                setIsEditing(false);
              }}
            >
              <FaCheck color="green" />
            </div>
            <div
              className="cursor-pointer d-flex align-items-center justify-content-center"
              onClick={() => {
                setIsEditing(false);
              }}
            >
              <FaTimes color="red" />
            </div>
          </div>
        ) : (
          <div className="d-flex flex-row gap-5">
            {comment}
            <div
              className="cursor-pointer d-flex align-items-center justify-content-center"
              onClick={() => setIsEditing(true)}
            >
              <MdEdit color="#BFBFBF" />
            </div>
          </div>
        )}
      </TableUi.td>
      <TableUi.td className="align-middle">{user_full}</TableUi.td>
      <TableUi.td className="align-middle">
        {qty}/{used_qty}
      </TableUi.td>
      <TableUi.td className="align-middle float-right">
        {validDelete && (
          <button
            className="btn btn-sm btn-danger"
            onClick={() =>
              confirm({
                title: "Are you sure?",
                icon: <IconExclamation className="text-primary" />,
                content: "You will not be able to undo this action",
                onOk() {
                  dispatch(
                    removeAlsoIncomeItem({
                      id: match.params.show,
                      also_income_item_id: id,
                    })
                  );
                  console.log("OK");
                },
                onCancel() {
                  console.log("Cancel");
                },
              })
            }
          >
            <IconTrash color="#fff" />
          </button>
        )}
      </TableUi.td>
    </TableUi.tr>
  );
}

const InformationNav = ({ show_data }) => {
  return (
    <div className="d-flex align-items-center flex-1 justify-content-between">
      <InformationItem
        icon={<IconNo className="text-primary" fill="#03b0f7" />}
        text={"Sup. order No:"}
        subText={show_data?.order_nr}
      />
      <InformationItem
        icon={<IconWarehouse className="text-primary" fill="#03b0f7" />}
        text={"Supplier code:"}
        subText={show_data?.supplier_code}
      />
      <InformationItem
        icon={<IconDocNumber className="text-primary" fill="#03b0f7" />}
        text={"Warehouse PO No:"}
        subText={show_data?.also_no}
      />
      {show_data.canceled_at ? (
        <InformationItem
          icon={<MdDateRange className="mr-2 text-primary" size={20} />}
          text={"Cancel date:"}
          subText={
            show_data?.canceled_at
              ? dayjs(show_data.canceled_at).format("YYYY-MM-DD")
              : ""
          }
        />
      ) : (
        <>
          <InformationItem
            icon={<MdDateRange className="mr-2 text-primary" size={20} />}
            text={"Date of arrival:"}
            subText={show_data?.arrival_date}
          />
          <InformationItem
            icon={<MdDateRange className="mr-2 text-primary" size={20} />}
            text={"Date exported:"}
            subText={
              show_data?.in_progress_at
                ? prettyDateFormat(show_data?.in_progress_at)
                : "-"
            }
          />
        </>
      )}

      <InformationItem
        icon={<IconWarehouse2 size={20} />}
        text={"Warehouse:"}
        subText={show_data?.add_to}
      />
    </div>
  );
};

const InformationItem = ({ icon, text, subText }) => {
  return (
    <span className="mx-3">
      <div className="d-flex">
        <div className="d-flex align-items-center mr-2">{icon}</div>
        <div className="text-sm text-black">
          <div className="font-semi-bold">{text}</div>
          <p
            className="mb-0"
            style={{
              lineHeight: 0.5,
            }}
          >
            {subText || " - "}
          </p>
        </div>
      </div>
    </span>
  );
};
